import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Typography } from '@material-ui/core';
import { formatAmount, THINSP, AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR } from 'utils/formatters';
import useStyles from './Amount.styles';

const ZERO_MINOR_PART_REGEXP = /^0+$/;

const Amount = props => {
  const { amount, showZeroMinorPart, component, className, ...other } = props;
  const { majorPart, minorPart: minorPartStr, currencySymbol: currencySymbolStr } = formatAmount(
    amount,
  );
  const classes = useStyles();

  const renderSeparatorAndMinorPart = minorPart => {
    let needMinorPart = false;

    if (minorPart) {
      needMinorPart = true;

      if (!showZeroMinorPart && ZERO_MINOR_PART_REGEXP.test(minorPart)) {
        needMinorPart = false;
      }
    }

    if (needMinorPart) {
      return (
        <div className={classes.minorContainer}>
          <span className={classes.separator}>{AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR}</span>
          <span className={classes.minor}>{minorPart}</span>
        </div>
      );
    }

    return null;
  };

  const renderCurrencySymbol = currencySymbol => {
    return (
      <span className={classes.currency}>
        {THINSP}
        {currencySymbol}
      </span>
    );
  };

  return (
    <Typography className={cn(classes.root, className)} component={component} {...other}>
      <span>{majorPart}</span>
      {renderSeparatorAndMinorPart(minorPartStr)}
      {renderCurrencySymbol(currencySymbolStr)}
    </Typography>
  );
};

Amount.propTypes = {
  amount: Type.shape({
    value: Type.number,
    currency: Type.shape({
      code: Type.string,
      minority: Type.number,
    }),
  }).isRequired,
  showZeroMinorPart: Type.bool,
  component: Type.string,
  color: Type.oneOf([
    'initial',
    'inherit',
    'primary',
    'secondary',
    'textPrimary',
    'textSecondary',
    'error',
  ]),
  variant: Type.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
  ]),
  align: Type.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  className: Type.string,
};

Amount.defaultProps = {
  showZeroMinorPart: false,
  color: 'textSecondary',
  align: 'inherit',
  component: 'span',
  variant: 'body2',
  className: null,
};

export default Amount;
